import {madnes_audio_fade_out, madnes_audio_loop, madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";
import {
    boom_spins_count,
    result_control,
    set_boom_spins_count,
    set_wild_lock_index,
    wild_lock
} from "./jokerboom_core_res_ctrl";
import {
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_set_pos, madnes_set_pos_y,
    madnes_set_scale, madnes_set_texture, madnes_set_visible, madnes_sprite_get_frame_name, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_anim_stop} from "../framework/src/engine/madnes/madnes_anims";
import {
    states,
    server_config,
    server_result,
    behavior_config,
    round_running,
    rotated,
    reels_pos,
    ico_he,
    set_rotated, set_forcestopnow, in_free_spins, reels_lenghts, fps, forcestopnow, picture_convert, set_round_running
} from "../framework/src/engine/madnes/madnes_variables";
import {ctrl_get_reel_symbol_name, get_memory_index, set_bonus_memory_index} from "./jokerboom_ctrl";
import {
    bet,
    madnes_is_in_autostart, madnes_reels_start,
    madnes_reels_stop,
    madnes_win_anim_reset
} from "../framework/src/engine/madnes/madnes";
import {cylinder_pos, last_symbol, symbols} from "./jokerboom_config";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {jb_print_reels, result_lock} from "./jokerboom_core_printer";
import {STATES} from "../framework/src/states/states";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";

var last_won = 0;
var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var in_free_spins_pos = 0;
var in_free_spins_total = 0;

var frame_blur = 1;
var frame_sharp = 0;

var autospin_force = false;
var autospin_force_enabled = false;

var audioForceStopPlayed = false;
var audioForceScatterPlayed = false;

export var jboom_last_server_result;

function rotate_onclick() {
    madnes_audio_play("button_click");
}

function get_current_time()
{
    return window.performance ? window.performance.now() : new Date().getTime();
}

export function jb_on_add_result({ addResult, symbolsMatrix }) {
    jboom_last_server_result = addResult.getData();
}

export function rotate_run()
{
    if(round_running) //waiting for end round
    {
        return;
    }
    else
    {
        rotate_start();
    }
}

var spin_start_time = null;

function rotate_start()
{
    autospin_force_enabled = false;

    if(rotated == 0)
    {
        // madnes_on_round_start();

        madnes_audio_loop("reel_spin");

        //console.log("rotate_start: ", wild_lock);

        if(wild_lock > -1) {
            var wildX = madnes_get_pos_x("reels_bufer_" + 0 + "_S" + (2 - wild_lock));
            var wildY = madnes_get_pos_y("reels_bufer_" + 0 + "_S" + (2 - wild_lock));

            madnes_set_pos("reels_bufer_" + 0 + "_WILD" + (2 - wild_lock), wildX, wildY);
            madnes_set_scale("reels_bufer_" + 0 + "_WILD"  + (2 - wild_lock), 1.1, 1.1);
        }

        set_bonus_memory_index(-1);

        for(var i = 0; i <= 2; i++) {
            madnes_anim_stop("reels_bufer_" + 0 + "_S" + i);
        }

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            for(var j = 0; j <= 2; j++)
            {
                var frameName = madnes_sprite_get_frame_name("reels_bufer_" + i + "_S" + j).replace("_blur", "");

                if(frameName.indexOf("symbol_Wild") !== -1)
                {
                    frameName = "symbol_Wild";
                    madnes_set_texture("reels_bufer_" + i + "_S" + j, "symbol_Wild_sprite_json");
                }

                madnes_sprite_set_frame_name("reels_bufer_" + i + "_S" + j, frameName);
            }
        }

        last_won = 0;
        spin_start_time = get_current_time();

        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i = 0, l = server_config.logic.reels.length; i < l; i++ )
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        // 	autostart = autostart*1-1;
        // }
        set_rotated(1);

        startposin = JSON.parse(JSON.stringify(stopposin));

        /*if(in_free_spins)
        {
            madnes_audio_loop("reel_fs_" + getRandomInt(0, 2));
        }
        else
        {
            madnes_audio_loop("reel_" + getRandomInt(0, 2));
        }*/

        //fadeout_all_lines();

        // if(!in_free_spins)
        // {
        // 	madnes_new_round(function() {
        // 		jboom_last_server_result = server_result;
        // 	});
        // }
        // else
        // {
        // 	set_round_running(true);
        // }

        set_boom_spins_count(boom_spins_count - 1);
        madnes_set_text("bonus_count", boom_spins_count);

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        can_stop = 0;

        rotate_start_time = get_current_time();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0);

        madnes_add_to_render(rotate_start);
        madnes_reels_start();

    } else {

        var time = get_current_time() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            behavior_config.reel.acceleration.accelerationHeight &&
            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc
            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }


        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            //madnes_audio_play("REEL_START_reels");
            //madnes_audio_loop("reel_spin");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = get_current_time();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                rotate_start_in_accel = 1;

                //rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = get_current_time();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;
            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;
                from_acce = true;

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    for(var j in server_config.logic.reels[i])
                    {
                        madnes_sprite_set_frame_name("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur");
                    }

                    for(var j = 0; j <= 2; j++)
                    {
                        var frameName = madnes_sprite_get_frame_name("reels_bufer_" + i + "_S" + j);
                        madnes_sprite_set_frame_name("reels_bufer_" + i + "_S" + j, frameName + "_blur");
                    }
                }

                /*for(var i = 0; i < cylinder_pos.length; i++)
                {
                    for(var )

                    var frameName = madnes_sprite_get_frame_name("reels_bufer_" + i + "_S0");
                    madnes_
                    console.log(madnes_sprite_get_frame_name("reels_bufer_" + i + "_S0"));

                    //madnes_set_texture("reels_bufer_" + i + "_S0", get_orig_texture_name(madnes_get_texture("reels_bufer_" + i + "_S0")) + "_blur");
                    //madnes_set_texture("reels_bufer_" + i + "_S1", get_orig_texture_name(madnes_get_texture("reels_bufer_" + i + "_S1")) + "_blur");
                    //madnes_set_texture("reels_bufer_" + i + "_S2", get_orig_texture_name(madnes_get_texture("reels_bufer_" + i + "_S2")) + "_blur");

                }*/

                madnes_rem_from_render(rotate_start);
                madnes_add_to_render(rotate_control);
            }
        }

        jb_print_reels();
    }
}

// Kontrola probihajici rotace valcu
var alldone_reels = new Array();
export var stopposin = new Array();
var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var all_set_for_stop = 0;

var from_acce = false;

var wild_anims = [];

function rotate_control()
{
    var time = get_current_time();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        // if(from_acce && behavior_config.reel.spin.motionBlur == 1) {
        // 	for(var i = 0; i < reels_pos.length; i++) {
        // 		/*madnes_sprite_set_frame("reels_bufer_" + i + "_S0", frame_blur);
        // 		madnes_sprite_set_frame("reels_bufer_" + i + "_S1", frame_blur);
        // 		madnes_sprite_set_frame("reels_bufer_" + i + "_S2", frame_blur);*/
        //
        // 		/*for(var j = 0; j <= 2; j++) {
        // 			var txt = get_texture_key(madnes_get_texture("reels_bufer_" + i + "_S" + j));
        // 			madnes_set_texture("reels_bufer_" + i + "_S" + j, txt + "_blur");
        // 		}*/
        // 	}
        // }

        from_acce = false;

        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone_reels[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }
    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow === 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }


                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );
            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone_reels[i] == 0)
                    {
                        if(i === alldone_reels.length - 1) {
                            madnes_audio_fade_out("reel_spin", 300);
                        }

                        sound_reel_stop(server_result.result.reelMatrix[0][i], i);

                        if(/*wild_lock > -1 && */ i === 0) {

                            //var wildY = madnes_get_pos_y("reels_bufer_" + 0 + "_S" + (2 - wild_lock));

                            madnes_set_pos_y("reels_bufer_" + 0 + "_WILD0", -9999);
                            madnes_set_pos_y("reels_bufer_" + 0 + "_WILD1", -9999);
                            madnes_set_pos_y("reels_bufer_" + 0 + "_WILD2", -9999);
                        }

                        for(var j in server_result.result.reelMatrix[0][i])
                        {
                            var spriteName = "reels_bufer_" + i + "_S" + ( 2 - j );
                            var symbolName = ctrl_get_reel_symbol_name(server_result.result.reelMatrix[0], i, j);

                            madnes_sprite_set_frame_name(spriteName, symbolName);

                            /*(function(x, y) {
                                setTimeout(function() {
                                    var spriteName = "reels_bufer_" + x + "_S" + ( 2 - y );
                                    var symbolName = ctrl_get_reel_symbol_name(server_result.result.reelMatrix[0], x, y).replace("_blur", "");

                                    if(symbolName == "symbol_Wild")
                                    {
                                        //console.log(spriteName, "wild_locked_json");
                                        madnes_set_texture(spriteName, "wild_locked_json");
                                    }
                                    else
                                    {
                                        madnes_sprite_set_frame_name(spriteName, symbolName);
                                    }

                                    //madnes_sprite_set_frame(spriteName, 0);
                                }, (1000 / fps) * j);
                            }(i, j))*/

                        }
                    }

                    for(var j in server_config.logic.reels[i])
                    {
                        madnes_sprite_set_frame_name("reels_bufer_" + i + "_" + j, ctrl_get_reel_symbol_name(server_config.logic.reels, i, j)/*.replace("_blur", "")*/);
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;

                var mt = behavior_config.reel.brake.moveTime;
                //var mt = behavior_config.reel.brake.moveBackTime;


                cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                //mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                    if(i === 2 && !in_free_spins && !madnes_is_in_autostart())
                    {
                        states.setState(STATES.FORCESPIN);
                        autospin_force_enabled = true;
                        // madnes_show_spin();
                    }
                }
                else
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        if(alldone_reels[i] !== 1)
                        {
                            if(i === 0 && wild_lock > -1)
                            {
                                set_bonus_memory_index(get_memory_index(bet));

                                var p = new Promise(function(res) {

                                    madnes_audio_play("symbol_joker");

                                    var spriteName = "reels_bufer_" + i + "_S" + (2 - wild_lock);
                                    madnes_set_pos("wild_bg", madnes_get_pos_x(spriteName), madnes_get_pos_y(spriteName));
                                    madnes_set_scale("wild_bg", 0.65, 0.65);

                                    madnes_tween_to("wild_bg", { 'x': 1.2, 'y': 1.2 }, {
                                        'scale': true,
                                        'duration': 350,
                                        'yoyo': true,
                                        'callback': function() {
                                            madnes_set_scale("wild_bg", 0.8, 0.8);
                                            madnes_set_pos("wild_bg", -9999, -9999);
                                            madnes_set_visible("wild_bg", false);
                                            res();
                                        }
                                    });

                                    madnes_tween_to(spriteName, { x: 1.15, y: 1.15 }, {
                                        'scale': true,
                                        'duration': 300,
                                        //'yoyo': true,
                                        'callback': function() {

                                            madnes_tween_to(spriteName, { x: 1.1, y: 1.1 }, {
                                                    'scale': true,
                                                    'duration': 200,
                                                    //'callback': function() {
                                                    //madnes_set_scale(spriteName, 1, 1);
                                                }
                                            );
                                        }
                                    });
                                });

                                wild_anims.push(p);
                            }
                        }

                        alldone_reels[i] = 1;
                    }
                }
            }
        }

        if(alldone_reels.indexOf(0) == -1)
        {
            audioForceStopPlayed = false;
            audioForceScatterPlayed = false;

            Promise.all(wild_anims).then(function() {
                wild_anims = [];

                //result_control();

                setTimeout(result_control, 260);
            });

            madnes_rem_from_render(rotate_control);
            madnes_reels_stop();
        }
    }

    jb_print_reels();
}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

function rotate_release()
{
    if(autospin_force_enabled)
    {
        autospin_force = true;
    }

    autospin_force_enabled = false;
}

function forcestop_press()
{
    autospin_force = false;
}

// Pozadavek na dotoceni valce
var rotate_stop_loading = 0;
export function rotate_stop()
{
    if(rotated != 0 && rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        rotate_stop_loading = 1;

        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {
                var spriteName = "reels_bufer_" + i + "_S" + ( 2 - j );
                var symbolName = ctrl_get_reel_symbol_name(server_result.result.reelMatrix[0], i, j).replace("_blur", "");
                var textureName = symbolName + "_sprite_json";

                /*if(symbolName == "symbol_Wild") {
                    textureName = symbolName + "_sprite2_json";
                }*/

                madnes_set_texture(spriteName, textureName);

                if(behavior_config.reel.spin.motionBlur == 1) {

                    madnes_sprite_set_frame_name(spriteName, symbolName + "_blur");
                } else {
                    madnes_sprite_set_frame_name(spriteName, symbolName + "");
                }
            }
        }

        set_wild_lock_index();

        setTimeout(function() {
            all_set_for_stop = 1;
            rotate_stop_loading = 0;
        }, (1000 / ( fps ) ));
        set_rotated(0);
    }
}

function is_in_autostart()
{
    return autostart * 1 > 0 || autostart == "∞";
}

function sound_reel_stop(reel, i)
{
    if(forcestopnow)
    {
        if(is_symbol_in_reel(reel, "symbol_Star"))
        {
            if(!audioForceScatterPlayed) {
                madnes_audio_play("symbol_star");
                audioForceScatterPlayed = true;
            }
            return;
        }

        if(!audioForceStopPlayed) {
            madnes_audio_play("reel_stop");
            audioForceStopPlayed = true;
        }
        return;
    }

    if (is_symbol_in_reel(reel, "symbol_Star"))
    {
        madnes_audio_play("symbol_star");
    }
    else
    {
        madnes_audio_play("reel_stop");
    }
}

function is_symbol_in_reel(reel, symbol)
{
    for(var i = 0; i < reel.length; i ++) {
        if(picture_convert[reel[i]] == symbol) {
            return true;
        }
    }

    return false;
}

function get_texture_key(textureName)
{
    return textureName.replace('_blur', '');
}

function betmenu_open() {
    //show_all_lines();
}